import React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';
import { defineMessages, useIntl } from 'react-intl';

import { ChevronDown } from '../../shared/DesignSystem/Icons';

const messages = defineMessages({
  selectOne: {
    id: 'PrimaryUserTitle.select',
    defaultMessage: 'Select one...',
    description: 'Default option title',
  },
  role: {
    id: 'PrimaryUserTitle.label',
    defaultMessage: 'Role',
    description: 'Role of user signing up',
  },
  projectManagement: {
    id: 'PrimaryUserTitle.projectManagement',
    defaultMessage: 'Project Management',
    description: 'Role of project management',
  },
  sales: {
    id: 'PrimaryUserTitle.sales',
    defaultMessage: 'Sales',
    description: 'Role of sales',
  },
  fieldTechInstallation: {
    id: 'PrimaryUserTitle.fieldTechInstallation',
    defaultMessage: 'Field Tech/Installation',
    description: 'Role of field tech installation',
  },
  operations: {
    id: 'PrimaryUserTitle.operations',
    defaultMessage: 'Operations',
    description: 'Role of operations',
  },
  officeAdministration: {
    id: 'PrimaryUserTitle.officeAdministration',
    defaultMessage: 'Office Administration',
    description: 'Role of office administration',
  },
  owner: {
    id: 'PrimaryUserTitle.owner',
    defaultMessage: 'Owner',
    description: 'Role of owner',
  },
  other: {
    id: 'PrimaryUserTitle.other',
    defaultMessage: 'Other',
    description: 'Role of other',
  },
});

const IconWrapper = styled.div`
  margin-right: 6px;
`;

type PrimaryUserTitleOption = {
  label: string;
  value: string;
  disabled?: boolean;
};

const PrimaryUserTitle = () => {
  const { formatMessage } = useIntl();

  const PrimaryUserTitleOptions = [
    {
      label: formatMessage(messages.owner),
      value: 'Owner',
    },
    {
      label: formatMessage(messages.officeAdministration),
      value: 'Office Administration',
    },
    {
      label: formatMessage(messages.operations),
      value: 'Operations',
    },
    {
      label: formatMessage(messages.projectManagement),
      value: 'Project Management',
    },
    {
      label: formatMessage(messages.sales),
      value: 'Sales',
    },
    {
      label: formatMessage(messages.fieldTechInstallation),
      value: 'Field Tech/Installation',
    },
    {
      label: formatMessage(messages.other),
      value: 'Other',
    },
  ];

  const options: PrimaryUserTitleOption[] = [
    {
      label: formatMessage(messages.selectOne),
      value: '',
      disabled: true,
    },
    ...PrimaryUserTitleOptions,
  ];

  return (
    <div className="form-field">
      <div className="input-wrap input-wrap--withicon">
        <Field
          as="select"
          name="primaryUserTitle"
          className="select-new-signup"
          data-testid="signup__primary-user-title"
        >
          {options.map((option) => (
            <option
              key={option.label}
              value={option.value}
              disabled={option.disabled}
              data-testid={`signup__primary-user-title-${option.value}`}
            >
              {option.label}
            </option>
          ))}
        </Field>
        <label htmlFor="primaryUserTitle">{formatMessage(messages.role)}</label>
        <IconWrapper>
          <ChevronDown size={20} color="#707B86" />
        </IconWrapper>
      </div>
    </div>
  );
};

export default PrimaryUserTitle;
